import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
    FormGroup, FormControlLabel, Checkbox, Typography, FormControl, IconButton
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import axios from "../../../../lib/axios";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import CustomAutocomplete from '../../../AutoComplete/AutoComplete';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import CloseIcon from '@mui/icons-material/Close';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'FoodName', label: 'Food Name', minWidth: 100 },
    { id: 'FoodGrpName', label: 'Abrv', minWidth: 100 },
    { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const FoodMaster = () => {
    const [formData, setFormData] = useState({
        FoodName: '',
        FoodGrpId: '',
        FoodSubGrpId: '',
        FoodClsId: '',
        FoodImg: '',
        UnitId: '',
        Abrv: '',
        SplPrice: '0.00',
        Price: '0.00',
        Remark: '',
        Status: ''
    });

    const [error, setError] = useState({
        FoodName: false,
        FoodGrpName: false
    });

    const navigate = useNavigate();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const location = useLocation();
    const [currentFoodId, setCurrentFoodId] = useState(null);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [lastInsertedFoodId, setLastInsertedFoodId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [Grp, setGrp] = useState([]);
    const [subGrp, setSubGrp] = useState([]);
    const [fclass, setFClass] = useState([]);
    const [unit, setUnit] = useState([]);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const FoodNameRef = useRef(null);
    const FoodGrpNameRef = useRef(null);
    const remarkRef = useRef(null);
    const [image, setImage] = useState(null);
    const [imgName, setImgName] = useState(null);

    useEffect(() => {
        if (location.state && location.state.FoodId) {
            setCurrentFoodId(location.state.FoodId);
            fetchFoodMst(location.state.FoodId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchFoodMst = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstFood/RetriveMstFood`, {
                FoodId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const foodData = response.data.Data[0];
                const fixImageUrl = (url) => {
                    if (!url) return '';
                    return url.replace(/^http:\/(?!\/)/, 'http://');
                };
                const fixedImg = fixImageUrl(foodData.FoodImg);

                setFormData({
                    FoodName: foodData.FoodName,
                    FoodGrpId: foodData.FoodGrpId,
                    FoodSubGrpId: foodData.FoodSubGrpId,
                    FoodSubGrpName: foodData.FoodSubGrpName,
                    FoodClsId: foodData.FoodClsId,
                    FoodClsName: foodData.FoodClsName,
                    Abrv: foodData.Abrv,
                    SplPrice: foodData.SplPrice,
                    Price: foodData.Price,
                    UnitId: foodData.UnitId,
                    UnitName: foodData.UnitName,
                    Remark: foodData.Remark,
                });
                setImage(fixedImg ? `${fixedImg}?t=${new Date().getTime()}` : null);
                setStatus(foodData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentFoodId(foodData.FoodId);
            }
        } catch (error) {
            toast.error('Error fetching food data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axios.post('MstFood/GetMstFoodDashBoard', {
                    start: 1,
                    PageSize: 1,
                    SearchText: ""
                });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (err) {
                toast.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    useEffect(() => {
        const fetchGrp = async () => {
            try {
                const response = await axiosInstance.post(`MstFoodGrp/GetdrpMstFoodGrp`, { Flag: "" });
                if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                    const transformed = response.data.Data.map(item => ({
                        Id: item.FoodGrpId,
                        Name: item.FoodGrpName
                    }));
                    setGrp(transformed);
                }
            } catch (error) {
                toast.error("Error fetching Group. Please try again.");
            }
        };
        fetchGrp();
    }, []);

    useEffect(() => {
        if (formData.FoodGrpId) {
            fetchSubGr(formData.FoodGrpId);
        } else {
            fetchSubGr(1);
        }
    }, []);

    const fetchSubGr = async (FoodGrpId) => {
        try {
            const response = await axiosInstance.post(`MstFoodSubGrp/GetdrpMstFoodSubGrp`, {
                Flag: "",
                FoodGrpId: FoodGrpId || 1
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const transformed = response.data.Data.map(item => ({
                    Id: item.FoodSubGrpId,
                    Name: item.FoodSubGrpName
                }));
                setSubGrp(transformed);
            }
        } catch (error) {
            toast.error("Error fetching SubGroup. Please try again.");
        }
    };

    useEffect(() => {
        const fetchClass = async () => {
            try {
                const response = await axiosInstance.post(`MstFoodCls/GetdrpMstFoodCls`,
                    {
                        Flag: ""
                    }
                );
                if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                    const transformed = response.data.Data.map(item => ({
                        Id: item.FoodClsId,
                        Name: item.FoodClsName
                    }));
                    setFClass(transformed);
                }
            } catch (error) {
                toast.error("Error fetching Group. Please try again.");
            }
        };

        fetchClass();
    }, []);

    useEffect(() => {
        const fetchUnit = async () => {
            try {
                const response = await axiosInstance.post(`MstUnit/getMstUnitdrp`,
                    {
                        Flag: ""
                    }
                );
                if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                    const transformed = response.data.Data.map(item => ({
                        Id: item.UnitId,
                        Name: item.UnitName
                    }));
                    setUnit(transformed);
                }
            } catch (error) {
                toast.error("Error fetching Group. Please try again.");
            }
        };

        fetchUnit();
    }, []);

    const handlePrevious = async () => {
        if (currentFoodId && currentFoodId > 1) {
            await fetchFoodMst(currentFoodId, "P");
        }
    };

    const handleNext = async () => {
        if (currentFoodId) {
            await fetchFoodMst(currentFoodId, "N");
        }
    };

    const handleInputChange = async (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (name === "FoodGrpId") {
            await fetchSubGr(value);
            setFormData(prev => ({ ...prev, FoodSubGrpId: '' }));
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === FoodNameRef.current) {
                FoodGrpNameRef.current.focus();
            } else {
                remarkRef.current.focus();
            }
        }
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
                setImgName(file.name);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async () => {

        let hasError = false;

        if (!formData.FoodName) {
            toast.error('Food is required.');
            setError(prev => ({ ...prev, FoodName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, FoodName: false }));
        }

        if (!formData.FoodGrpId) {
            toast.error('Food Group is required.');
            setError(prev => ({ ...prev, FoodGrpId: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, FoodGrpId: false }));
        }

        if (!formData.FoodSubGrpId) {
            toast.error('Food SubGroup is required.');
            setError(prev => ({ ...prev, FoodSubGrpId: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, FoodSubGrpId: false }));
        }

        if (!formData.UnitId) {
            toast.error('Unit is required.');
            setError(prev => ({ ...prev, UnitId: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, UnitId: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                FoodName: formData.FoodName,
                FoodGrpId: formData.FoodGrpId,
                FoodSubGrpId: formData.FoodSubGrpId,
                FoodClsId: formData.FoodClsId,
                UnitId: formData.UnitId,
                Abrv: formData.Abrv,
                SplPrice: formData.SplPrice,
                Price: formData.Price,
                Remark: formData.Remark,
                FoodImg: image?.startsWith('data:') ? image : formData.FoodImg,
                ImgName: imgName,
                Status: Status
            };

            let response;
            if (mode === 'edit') {
                payload.FoodId = currentFoodId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axiosInstance.patch(`MstFood/UpdateMstFood`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post(`MstFood/InsertMstFood`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedFoodId(response.data.Data)
                    await fetchFoodMst(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentFoodId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            toast.error('Error saving/updating food. Please try again.');
        }
    };

    const handleEdit = async () => {
        let Flag = await checkAndLock(currentFoodId, "MstFood", "FoodId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            FoodName: '',
            FoodGrpId: '',
            FoodSubGrpId: '',
            FoodClsId: '',
            Abrv: '',
            SplPrice: '0.00',
            Price: '0.00',
            UnitId: '1',
            Remark: '',
            Status: ''
        });
        setCurrentFoodId(null);

        setTimeout(() => {
            FoodNameRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchFoodMst(1, "L");
            await UnLock(currentFoodId, "MstFood", "FoodId");
            setStatus("1");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const handleExit = () => {
        navigate('/foodtable')
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        let Flag = await checkAndLock(currentFoodId, "MstFood", "FoodId");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                const response = await axiosInstance.post("MstFood/DeleteMstFood", {
                    FoodId: currentFoodId
                });
                if (response.data.Status === 0) {
                    toast.success(response.data.Message || 'Record Deleted.');
                    await fetchFoodMst(currentFoodId, "P");
                    setStatus("1");
                    setMode('view');
                    setIsFormDisabled(true);
                } else {
                    toast.warn(response.data.Message || 'Failed to delete the record.');
                }
                break;
            case 1: toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default: toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    return (
        <>
            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentFoodId || currentFoodId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                // sx={{ margin: '0px 10px' }}
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentFoodId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Food Master
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName={"Food Master"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Box sx={{ position: 'relative' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={4} lg={4}>

                                    <CustomAutocomplete
                                        options={fclass}
                                        id="FoodClsName-autocomplete"
                                        name="FoodClsId"
                                        label={<span>Food Class<span style={{ color: 'red' }}>*</span></span>}
                                        value={fclass.find(c => c.Id === formData.FoodClsId) || ''}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        className="custom-textfield"
                                        variant='filled'
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} lg={3}>
                                    <CustomAutocomplete
                                        options={Grp}
                                        id="FoodGrpName-autocomplete"
                                        name="FoodGrpId"
                                        label={<span>Food Group<span style={{ color: 'red' }}>*</span></span>}
                                        value={Grp.find(g => g.Id === formData.FoodGrpId) || ''}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        className="custom-textfield"
                                        variant='filled'
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} lg={3}>
                                    <CustomAutocomplete
                                        options={subGrp}
                                        id="FoodSubGrpName-autocomplete"
                                        name="FoodSubGrpId"
                                        label={<span>Food SubGroup<span style={{ color: 'red' }}>*</span></span>}
                                        value={subGrp.find(s => s.Id === formData.FoodSubGrpId) || ''}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        className="custom-textfield"
                                        variant='filled'
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} lg={4}>
                                    <TextField
                                        id="FoodName"
                                        name="FoodName"
                                        label={
                                            <span>
                                                Food <span style={{ color: 'red' }}>*</span>
                                            </span>
                                        }
                                        variant="filled"
                                        fullWidth
                                        className="custom-textfield"
                                        value={formData.FoodName}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        error={error.FoodName}
                                        helperText={error.FoodName && ""}
                                        inputRef={FoodNameRef}
                                        onKeyDown={handleKeyPress}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} lg={3}>
                                    <TextField
                                        id="Abrv"
                                        name="Abrv"
                                        label="Abrv"
                                        variant="filled"
                                        fullWidth
                                        className="custom-textfield"
                                        value={formData.Abrv}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        inputRef={remarkRef}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} lg={3}>
                                    <CustomAutocomplete
                                        options={unit}
                                        id="unit-autocomplete"
                                        name="UnitId"
                                        label={<span>Unit<span style={{ color: 'red' }}>*</span></span>}
                                        value={unit.find(u => u.Id === formData.UnitId) || ''}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        className="custom-textfield"
                                        variant='filled'
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} lg={4}>
                                    <TextField
                                        id="SplPrice"
                                        name="SplPrice"
                                        label="Special Price"
                                        variant="filled"
                                        fullWidth
                                        className="custom-textfield"
                                        value={formData.SplPrice}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        inputRef={remarkRef}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} lg={3}>
                                    <TextField
                                        id="Price"
                                        name="Price"
                                        label="Price"
                                        variant="filled"
                                        fullWidth
                                        className="custom-textfield"
                                        value={formData.Price}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        inputRef={remarkRef}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} lg={3}>
                                    <TextField
                                        id="Remark"
                                        name="Remark"
                                        label="Remark"
                                        variant="filled"
                                        fullWidth
                                        className="custom-textfield"
                                        value={formData.Remark}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        inputRef={remarkRef}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={1}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={isFormDisabled}
                                                    checked={Status === "1"}
                                                    onChange={handleChangeStatus}
                                                />
                                            }
                                            label="Status"
                                        />
                                    </FormGroup>
                                </Grid>

                                <Box
                                    sx={{
                                        width: 110,
                                        height: 110,
                                        border: '1px dashed #000',
                                        borderRadius: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: '#fff',
                                        cursor: 'pointer',
                                        overflow: 'hidden',
                                        position: 'absolute',
                                        top: 8,
                                        right: 0,
                                        zIndex: 10,
                                    }}
                                    onClick={() => document.getElementById('item-image').click()}
                                >
                                    {image ? (
                                        <img
                                            src={image}
                                            alt="Item"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <Typography variant="caption" color="textSecondary" textAlign="center">
                                            Click to upload
                                        </Typography>
                                    )}

                                    {image && (
                                        <IconButton
                                            size="small"
                                            sx={{
                                                position: 'absolute',
                                                top: 1,
                                                right: 1,
                                                width: 20,
                                                height: 20,
                                                padding: 0,
                                                backgroundColor: 'rgba(255,255,255,0.7)',
                                                '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setImage('');
                                                setImgName('');
                                            }}
                                            disabled={isFormDisabled}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    )}

                                    <input
                                        type="file"
                                        id="item-image"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={handleImageUpload}
                                        disabled={isFormDisabled}
                                    />
                                </Box>
                            </Grid>
                        </Box>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>

                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="Food Master"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />
                }
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default FoodMaster;